// https://stackoverflow.com/questions/1634748/how-can-i-delete-a-query-string-parameter-in-javascript
// Code is largely from stackoverflow, but had to add support to preserve hash routes
export const removeURLParameter = (url, parameter) => {
  const urlHashParts = url.split('#');
  const urlParamParts = urlHashParts[0].split('?');
  if (urlParamParts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const params = urlParamParts[1].split(/[&;]/g);

    // reverse iteration as may be destructive
    for (let i = params.length; i-- > 0;) {
      // idiom for string.startsWith
      if (params[i].lastIndexOf(prefix, 0) !== -1) {
        params.splice(i, 1);
      }
    }
    const urlWithParams = urlParamParts[0] + (params.length > 0 ? `?${params.join('&')}` : '');
    if (urlHashParts.length >= 2) {
      urlHashParts[0] = urlWithParams;
      return urlHashParts.join('#');
    }
    return urlWithParams;
  }
  return url;
};
//# sourceMappingURL=url.js.map